"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeAbilityHandler = exports.ShapeActorAbilityFactory = exports.ShapeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class ShapeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Shape;
        this.__typeName = "Shape";
    }
}
exports.ShapeAbilityArgs = ShapeAbilityArgs;
let ShapeActorAbilityFactory = class ShapeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Shape", "All", 4);
    }
};
ShapeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Shape")
], ShapeActorAbilityFactory);
exports.ShapeActorAbilityFactory = ShapeActorAbilityFactory;
let ShapeAbilityHandler = class ShapeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.All);
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                sequence = sequence.pushSequence("parallel");
                targets.forEach(targetId => container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.EffectOnHitEffectArgs("Shaped", "Applies wither on attack", 100, new core_1.WitheringEffectArgs("Focus", 10), Duration_1.Duration.Permanent),
                    onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "TimeCircleLightPillar"))
                }));
            }
        });
    }
};
ShapeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Shape)
], ShapeAbilityHandler);
exports.ShapeAbilityHandler = ShapeAbilityHandler;
